import { Component, OnInit } from '@angular/core';
import { IndexedDBService } from '../../../../services/indexed.db.service';

@Component({
  selector: 'app-submit',
  imports: [],
  templateUrl: './submit.component.html',
  styleUrl: './submit.component.scss'
})
export class SubmitComponent implements OnInit {

  constructor(private indexedDBService: IndexedDBService) {}

  ngOnInit(): void {
   this.indexedDBService.clearRfqIntakeData().subscribe({
    next: () => {
      console.log("clearRfqIntakeData success");
    },
    error: (error) => {
      console.log("clearRfqIntakeData error",error);
    }
   }) ;
  }
}
